export default __webpack_public_path__ + "static/media/calendar.ec453b58.svg";